import { APIRoute } from '@/modules/utils'

export type Body = {
  token: string
  plainPassword: {
    first: string
    second: string
  }
}

export type Response = {
  success?: boolean
}

export const Route: APIRoute = {
  method: 'PATCH',
  path: '/v2/account/change-password',
}
